export const ROUTERS = {
    USER: {
        HOMEPAGE: "",
        LOGINPAGE: "/auth/login",
        REGISTERPAGE: "/auth/register",
        FORGOTPASSWORDPAGE: "/auth/forgot-password",
        PROFILEPAGE: "/customer/info",
        PASSWORDPAGE: "/customer/password",
        NEWSPAGE: "/news/index",
        NEWSDETAILPAGE: "/news/detail/:id",
        TOURPAGE: "/tour/index",
        TOURDETAILPAGE: "/tour/detail/:id",
        BOOKINGPAGE: "/booking/:id",
        BOOKINGMESSAGEPAGE: "/booking/message",
        CALENDARPAGE: "/calendar/index",
        CALENDARDETAILPAGE: "/calendar/detail/:id",
        SEARCHPAGE: "/tour/search",
        SEARCHDESTINATIONPAGE: "/tour/search-destination",
        ACTIVATEPAGE: "/customer/activate/:id",
        ABOUTPAGE: "/about",
        DESTINATIONSPAGE: "/destinations/index",
    },
    ADMIN: {
        LOGINPAGE: "/manage/auth/login",
        FORGOTPASSWORDPAGE: "/manage/auth/forgot-password",
        CUSTOMERPAGE: "/manage/customers",
        TOURPAGE: "/manage/tours/index",
        TOURINSERTPAGE: "/manage/tours/insert",
        TOURUPDATEPAGE: "/manage/tours/edit/:id",
        SCHEDULEPAGE: "/manage/schedules",
        SCHEDULEINSERTPAGE: "/manage/schedules/insert",
        CALENDARPAGE: "/manage/calendars",
        CALENDARDETAILSPAGE: "/manage/calendars/detail/:id",
        PROFILEPAGE: "/manage/info",
        PASSWORDPAGE: "/manage/password",
        DASHBOARDPAGE: "/manage/dashboard",
        PROMOTIONPAGE: "/manage/promotions",
        PROMOTIONUPDATEPAGE: "/manage/promotions/edit/:id",
        PROMOTIONINSERTPAGE: "/manage/promotions/insert",
        NEWSPAGE: "/manage/news",
        NEWSINSERTPAGE: "/manage/news/insert",
        NEWSUPDATEPAGE: "/manage/news/edit/:id",
    },
    ERROR: {
        ERROR500PAGE: '/error/500',
        MANAGEERROR500PAGE: '/manage/error/500',
    },
}